/**
 * Контракт между API и мини-аппом.
 *
 * Денежные суммы всюду передаются строками: JSON не умеет bigint, а number
 * потерял бы точность на больших балансах. Разбирать их следует через
 * pawsFromJson, а не Number().
 */
export const CRASH_ERROR_CODES = {
    BettingClosed: "betting_closed",
    AlreadyBet: "already_bet",
    NoActiveBet: "no_active_bet",
    InsufficientFunds: "insufficient_funds",
    StakeTooLow: "stake_too_low",
    StakeTooHigh: "stake_too_high",
    Unauthorized: "unauthorized",
    RateLimited: "rate_limited",
};
//# sourceMappingURL=types.js.map